import { useEffect, useImperativeHandle, forwardRef } from "react";
import arisChatIcon from "../../Assets/images/arisChatIcon.png";
import ReactMarkdown from "react-markdown";
import removeMarkdown from "remove-markdown";
import rehypeRaw from 'rehype-raw';
import { getPreferredVideo } from "../../Utils/media";
import { useState } from "react";
import "./style.css";

const AiChatComponent = forwardRef(
  (
    {
      chat,
      isSurvey,
      onOptionSelected,
      isAiLoading,
      manualEnteredData,
      clearManualData,
      lastQuestID,
      handleEnterWithSubmit,
      iselements,
      isLastPart,
    },
    ref
  ) => {
    const [selectedChoice, setSelectedChoice] = useState([]);
    const [question, setQuestion] = useState(chat?.content);
    const [isoperationCompleted, setIsoperationCompleted] = useState(false);
    const [doWeNeedToHighliteOthers, setdoWeNeedToHighliteOthers] =
      useState(false);
    const [isVideoReady, setIsVideoReady] = useState(false);
    const [selectedSimpleOption, setSelectedSimpleOption] = useState(null); // for simple string options in Elements intro

    useEffect(() => {
      setQuestion(chat?.content);
    }, [chat]);

    useEffect(() => {
      if (selectedChoice?.includes("Other (Write your own below)"))
        handleEnterWithSubmit();
    }, [selectedChoice]);

    const VideoFile = getPreferredVideo(
      `${process.env.REACT_APP_STATIC_CONTENT}ui-components/Sphere_Loader.webm`,
      `${process.env.REACT_APP_STATIC_CONTENT}ui-components/sphere-ios.mov`
    );

    const onOptionSelectedFunction = (item) => {
      let tmp = {
        desc: chat?.content?.desc,
        options: chat?.content?.options?.filter(
          (fill) => item?.label === fill?.label
        ),
        hearderQuest: chat?.content?.desc,
      };
      // chat = { ...tmp };
      setQuestion(tmp);
      onOptionSelected(item);
      setIsoperationCompleted(true);
    };

    const markdownToString = (markdown) => {
      return removeMarkdown(markdown).trim();
    };
    function extractFirstBoldText(markdownText) {
      const match =
        (markdownText && markdownText?.match(/\*\*(.*?)\*\*/)) || null;
      return match ? match[1] : null;
    }
    // Replace trademark text variants with superscript, globally.
    // Always return a string so downstream `.replace()` calls are safe.
    const formatTrademarks = (text) => {
      if (!text || typeof text !== "string") return "";
      // To avoid double-wrapping, skip segments already inside <sup>...</sup>
      const parts = text.split(/(<sup>.*?<\/sup>)/gi);
      const formatted = parts
        .map((segment) => {
          // If this segment is already a <sup>...</sup>, leave it untouched
          if (/^<sup>.*<\/sup>$/i.test(segment)) return segment;
          // Replace unicode trademark symbol and literal \u2122 with superscript ™
          // Then replace standalone TM (word) with superscript TM
          return segment
            .replace(/\\u2122|™/g, "<sup>™</sup>")
            .replace(/\bTM\b/g, "<sup>TM</sup>");
        })
        .join("");
      return formatted;
    };

    // Normalize any mixed content: apply trademark formatting and
    // ensure we return a plain string with Markdown-friendly newlines.
    const safeNormalize = (value) => {
      const s = formatTrademarks(value);
      return typeof s === "string" ? s.replace(/\n/g, "\n\n") : "";
    };
    const handleChoiceClick = (choice) => {
      setSelectedChoice((prev) => {
        if (prev.includes(choice?.label))
          return prev.filter((ele) => ele !== choice?.label); // If already selected, do nothing

        const updated = [...prev, choice?.label];
        if (updated.length > chat?.max_ans_count) {
          updated.shift(); // Remove first selected if over the limit
        }
        return updated;
      });
    };

    const actionCallOnAnswerSubmit = () => {
      if (
        selectedChoice?.includes("Other (Write your own below)") &&
        manualEnteredData === ""
      ) {
        return;
      }
      let updatedChoice = selectedChoice;

      if (selectedChoice?.includes("Other (Write your own below)")) {
        updatedChoice = [
          ...(selectedChoice?.filter((sc) => sc !== "Other (Write your own below)") ||
            []),
          manualEnteredData,
        ];
        setSelectedChoice(updatedChoice); // still update the state for UI sync
      }

      let tmp = {
        desc: chat?.content?.desc,
        options: chat?.content?.options?.filter((fill) =>
          updatedChoice.includes(fill?.label)
        ),
      };

      setQuestion(tmp);

      setTimeout(() => {
        onOptionSelected({
          question_id: chat?.question_id,
          selectedChoice: updatedChoice,
          type: "showAsListInUserChat",
          headerQuest: extractFirstBoldText(chat?.content?.desc) || "",
        });
        setIsoperationCompleted(true);
        clearManualData();
      }, 100);
    };

    useImperativeHandle(ref, () => ({
      actionCallOnAnswerSubmit: () => {
        actionCallOnAnswerSubmit();
      },
    }));

    const elementDomainButtonConst = [
      {
        id: 1,
        domain: "Identity",
        description: "How you express and engage with others",
      },
      {
        id: 2,
        domain: "Cognition",
        description: "How you think and process the world",
      },
      {
        id: 3,
        domain: "Judgment",
        description: "How you evaluate choices and make decisions",
      },
      {
        id: 4,
        domain: "Resolution",
        description: "How you handle conflict and challenge",
      },
      {
        id: 5,
        domain: "Motivation",
        description: "What drives you to grow and take action",
      },
    ];

    // Render function for survey chat
    const renderSurveyChat = () => (
      <>
        <div className="ai-chat-hero-container">
          {/* Show video icon only for the latest message */}
          {isLastPart ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              webkit-playsinline="true"
              className="aris-chat-icon-video"
              src={VideoFile}
            />
          ) : (
            <div></div>
          )}

          {/* <img src={arisChatIcon} alt="arisChatIcon" className="aris-chat-icon" /> */}
          {/* {loading ?<>} */}
          <div className="ai-chat-container">
            {chat?.content?.desc === "" ? (
              <div className="loader-chat-wait"></div>
            ) : (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                components={{
                  h1: "h3",
                  h2: ({ node, ...props }) => (
                    <h4 style={{ marginBottom: '0px' }} {...props} />
                  ),
                  p: ({ node, ...props }) => (
                    <p style={{ marginBottom: '0px' }} {...props} />
                  ),
                  sup: ({ node, ...props }) => (
                    <sup style={{ fontSize: '0.6em', verticalAlign: 'super' }} {...props} />
                  ),
                  a: ({ node, href, ...props }) => (
                    <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
                  ),
                }}
              >
                {safeNormalize(chat?.content?.desc)}
              </ReactMarkdown>
              // <>{chat?.content}</>
            )}
          </div>
        </div>

        <div className="ai-chat-multi-option-container">
          {question?.options?.map((item, index) => (
            <div
              onClick={() => {
                if (!isoperationCompleted) {
                  if (chat?.max_ans_count === 1) {
                    if (item?.label === "Other (Write your own below)") {
                      setdoWeNeedToHighliteOthers(true);
                      return;
                    } else {
                      onOptionSelectedFunction({
                        ...item,
                        question_id: chat?.question_id,
                        headerQuest:
                          extractFirstBoldText(chat?.content?.desc) || "",
                      });
                    }
                  } else {
                    handleChoiceClick(item);
                    // onOptionSelectedFunction({
                    //   ...item,
                    //   question_id: chat?.question_id,
                    // });
                  }
                }
              }}
              className={`ai-chat-multi-option-label ${item?.type === "link" ||
                selectedChoice.includes(item?.label) ||
                (doWeNeedToHighliteOthers &&
                  item?.label === "Other (Write your own below)")
                ? "ai-chat-multi-option-label-link "
                : ""
                } ${isoperationCompleted && "ai-chat-disabled-button-clrd"}`}
              key={index}
            >
              {item?.label}
            </div>
          ))}
        </div>

        {(chat?.message_type === "cta" ||
          chat?.message_type === "actionable" ||
          chat?.message_type === "interactive" ||
          chat?.message_type === "clickable") &&
          chat?.action_text && (
            <div className={`ai-chat-multi-option-container ai-chat-option `}>
              <div
                onClick={() => {
                  // Respect disabled visual state with matching logic guards
                  const shouldBeDisabled = (
                    (chat?.max_ans_count > 1 &&
                      chat?.min_ans_count > selectedChoice?.length) ||
                    isoperationCompleted ||
                    (selectedChoice?.includes("Other (Write your own below)") &&
                      manualEnteredData === "")
                  );
                  if (shouldBeDisabled) return;

                  if (chat?.max_ans_count > 1) {
                    if (chat?.min_ans_count <= selectedChoice?.length) {
                      actionCallOnAnswerSubmit();
                    }
                  } else {
                    onOptionSelectedFunction({
                      label: markdownToString(chat?.action_text),
                      question_id: chat?.question_id,
                      type: "CTA",
                      startAssessment: chat?.startAssessment,
                      nextCategoryId: chat?.nextCategoryId,
                      userStory: chat?.userStory,
                      load_chat: chat?.load_chat,
                      add_relation: chat?.add_relation,
                      isSimpleClickable: chat?.message_type === "clickable",
                    });
                  }
                }}
                className={`ai-chat-multi-option-label ai-chat-option ${true ? "ai-chat-multi-option-label-link" : ""
                  } ${((chat?.max_ans_count > 1 &&
                    chat?.min_ans_count > selectedChoice?.length) ||
                    isoperationCompleted ||
                    (selectedChoice?.includes("Other (Write your own below)") &&
                      manualEnteredData === "")) &&
                  " ai-chat-disabled-button"
                  }`}
              >
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    h1: "h3",
                    h2: "h4",
                    p: "span",
                  }}
                >
                  {formatTrademarks(chat?.action_text)}
                </ReactMarkdown>
              </div>
            </div>
          )}
      </>
    );

    // Render function for elements chat
    const renderElementsChat = () => (
      <>
        <div className={iselements ? "ai-chat-hero-container-element" : "ai-chat-hero-container"}>
          {/* Show video icon only for the latest message */}
          {isLastPart ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              webkit-playsinline="true"
              className={`aris-chat-icon-video ${isVideoReady ? "loaded" : ""}`}
              src={VideoFile}
              onLoadedData={() => setIsVideoReady(true)}
            />
          ) : (
            <div></div>
          )}
          {/* <img src={arisChatIcon} alt="arisChatIcon" className="aris-chat-icon" /> */}
          {/* {loading ?<>} */}
          <div className="ai-chat-container">
            {chat?.content === "" ? (
              <div className="loader-chat-wait"></div>
            ) : (
              <>
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  components={{
                    h1: "h3",
                    h2: "h4",
                    p: ({ node, ...props }) => (
                      <p style={{ marginBottom: '10px' }} {...props} />
                    ),
                    a: ({ node, href, ...props }) => (
                      <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
                    ),
                  }}
                >
                  {safeNormalize(chat?.content)}
                </ReactMarkdown>
                {chat?.type === "elementDomainButton" && (
                  <div className="elementDomainButton-hero-container">
                    {chat?.followUp?.length > 0
                      ? chat?.followUp?.map((_f) => (
                        <div
                          className={`elementDomainButton-container `}
                          key={_f}
                          onClick={() => {
                            if (!isoperationCompleted) {
                              onOptionSelected({
                                domain: _f,
                                isFirst: false,
                              });
                              setIsoperationCompleted(true);
                            }
                          }}
                        >
                          <div
                            className={`elementDomainButton-container-typo ${isoperationCompleted && "disabled-option"
                              }`}
                          >
                            {_f}
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6.35378 2.64622L11.3538 7.64622C11.4003 7.69265 11.4372 7.7478 11.4623 7.8085C11.4875 7.86919 11.5004 7.93426 11.5004 7.99997C11.5004 8.06567 11.4875 8.13074 11.4623 8.19144C11.4372 8.25214 11.4003 8.30728 11.3538 8.35372L6.35378 13.3537C6.25996 13.4475 6.13272 13.5002 6.00003 13.5002C5.86735 13.5002 5.7401 13.4475 5.64628 13.3537C5.55246 13.2599 5.49976 13.1326 5.49976 13C5.49976 12.8673 5.55246 12.74 5.64628 12.6462L10.2932 7.99997L5.64628 3.35372C5.59983 3.30726 5.56298 3.25211 5.53784 3.19141C5.5127 3.13072 5.49976 3.06566 5.49976 2.99997C5.49976 2.93427 5.5127 2.86921 5.53784 2.80852C5.56298 2.74782 5.59983 2.69267 5.64628 2.64622C5.69274 2.59976 5.74789 2.56291 5.80859 2.53777C5.86928 2.51263 5.93434 2.49969 6.00003 2.49969C6.06573 2.49969 6.13079 2.51263 6.19148 2.53777C6.25218 2.56291 6.30733 2.59976 6.35378 2.64622Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                        </div>
                      ))
                      : elementDomainButtonConst?.map((_domain) => (
                        <div
                          className={"elementDomainButton-container"}
                          key={_domain?.id}
                          onClick={() => {
                            if (!isoperationCompleted) {
                              onOptionSelected({
                                domain: _domain?.domain,
                                query: _domain?.description,
                                isFirst: true,
                              });
                              setIsoperationCompleted(true);
                            }
                          }}
                        >
                          <div
                            className={`elementDomainButton-container-typo ${isoperationCompleted && "disabled-option"
                              }`}
                          >
                            <b>{_domain?.domain}</b> : {_domain?.description}
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6.35378 2.64622L11.3538 7.64622C11.4003 7.69265 11.4372 7.7478 11.4623 7.8085C11.4875 7.86919 11.5004 7.93426 11.5004 7.99997C11.5004 8.06567 11.4875 8.13074 11.4623 8.19144C11.4372 8.25214 11.4003 8.30728 11.3538 8.35372L6.35378 13.3537C6.25996 13.4475 6.13272 13.5002 6.00003 13.5002C5.86735 13.5002 5.7401 13.4475 5.64628 13.3537C5.55246 13.2599 5.49976 13.1326 5.49976 13C5.49976 12.8673 5.55246 12.74 5.64628 12.6462L10.2932 7.99997L5.64628 3.35372C5.59983 3.30726 5.56298 3.25211 5.53784 3.19141C5.5127 3.13072 5.49976 3.06566 5.49976 2.99997C5.49976 2.93427 5.5127 2.86921 5.53784 2.80852C5.56298 2.74782 5.59983 2.69267 5.64628 2.64622C5.69274 2.59976 5.74789 2.56291 5.80859 2.53777C5.86928 2.51263 5.93434 2.49969 6.00003 2.49969C6.06573 2.49969 6.13079 2.51263 6.19148 2.53777C6.25218 2.56291 6.30733 2.59976 6.35378 2.64622Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </>
              // <>{chat?.content}</>
            )}
          </div>
        </div>
        {chat?.options?.length > 0 && (
          <div className="ai-chat-multi-option-container">
            {chat?.options?.map((item, index) => (
              <div
                onClick={() => {
                  if (isoperationCompleted) {
                    return;
                  }
                  onOptionSelectedFunction({
                    type: "relationshipAdvice",
                    text: item,
                  });
                  setIsoperationCompleted(true);
                }}
                className={`ai-chat-multi-option-label ${item?.type === "link" ? "ai-chat-multi-option-label-link" : ""
                  }  ${isoperationCompleted && "ai-chat-disabled-button-clrd"}`}
                key={index}
              >
                {item}
              </div>
            ))}
          </div>
        )}
      </>
    );
    // Render function for regular chat
    const renderRegularChat = () => {
      return (
        <>
          <div className="ai-chat-hero-container">
            {/* Show video icon only for the latest message */}
            {isLastPart ? (
              <video
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
                className={`aris-chat-icon-video ${isVideoReady ? "loaded" : ""}`}
                src={VideoFile}
                onLoadedData={() => setIsVideoReady(true)}
              />
            ) : (
              <div></div>
            )}
            <div className="ai-chat-container">
              {chat?.content === "" ? (
                <div className="loader-chat-wait"></div>
              ) : (
                <>
                  <ReactMarkdown
                    rehypePlugins={[rehypeRaw]}
                    components={{
                      h1: "h3",
                      h2: "h4",
                      p: ({ node, ...props }) => (
                        <p style={{ marginBottom: '10px' }} {...props} />
                      ),
                      a: ({ node, href, ...props }) => (
                        <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
                      ),
                    }}
                  >
                    {safeNormalize(chat?.content)}
                  </ReactMarkdown>
                </>
              )}
            </div>
          </div>
          {chat?.options?.length > 0 && (
            <div className="ai-chat-multi-option-container">
              {chat?.options?.map((item, index) => (
                <div
                  onClick={() => {
                    if (isoperationCompleted) {
                      return;
                    }
                    setSelectedSimpleOption(item);
                    onOptionSelectedFunction({
                      type: "relationshipAdvice",
                      text: item,
                    });
                    setIsoperationCompleted(true);
                  }}
                  className={`ai-chat-multi-option-label ${(item?.type === "link" || selectedSimpleOption === item) ? "ai-chat-multi-option-label-link" : ""}  ${isoperationCompleted && "ai-chat-disabled-button-clrd"}`}
                  key={index}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </>
      )
    };

    // Return the appropriate render function based on props
    return isSurvey ? renderSurveyChat() : iselements ? renderElementsChat() : renderRegularChat();
  }
);

export default AiChatComponent;
